import React from 'react';
import {useLocation} from "react-router-dom";
import ItemTimeline from '../../components/common/ItemTimeline'


const TimelinePage = () => {
    const location = useLocation()
    const news = location.state.news; //카드뉴스에서 받아온 state값 (단일 뉴스 데이터)

    return (
        <div className='timeline container'>
            <div className='inner_container'>
                <div className='flex_layout timeline_top'>
                    <span className='title_sm'>{`"${news.subject}"과 관련하여 ${news.samenewscounts}번의 보도가 있습니다.`}</span>
                </div>
                <ItemTimeline news={news}/>
            </div>
        </div>
    );
};

export default TimelinePage;